import { motion } from 'framer-motion';
import { sectionAnimVariants } from '../../../constants/animationVariants';
import { useFeatureContext } from '../../../contexts/FeatureProvider';
import useCheckUserFeaturePermissions from '../../../hooks/useCheckUserFeaturePermissions';
import { formatFeatureName } from '../../../utils/commonFunctions';
import AcademiaNotFound from '../../CommonComps/AcademiaNotFound';
import SetupCard from '../../CommonComps/Cards/SetupCard';
import SetupCardBodyInfo from '../../CommonComps/Cards/SetupCardBodyInfo';
import AcademiaLoading from '../../CommonComps/Loadings/AcademiaLoading';
import NoTableDataFound from '../../CommonComps/NoTableDataFound';
import PageHeader from '../../CommonComps/Titles/PageHeader';
import AddFeatureAction from './AddFeatureAction';
import FilterFeaturesDiv from './FilterFeaturesDiv';

const ShowAllFeatures = () => {
  // integration of context hooks here
  const {
    isError,
    isLoading,
    isSuccess,
    featureList,
    setShowDeleteModal,
    setTargetedFeature,
  } = useFeatureContext();

  // integration of custom hooks here
  const { featureBasedPermissions } = useCheckUserFeaturePermissions('feature');

  console.log('FEATURE LIST: ', featureList, featureBasedPermissions);

  // rendering show all features section component here
  return (
    <section>
      {isLoading ? (
        <AcademiaLoading />
      ) : isSuccess ? (
        featureBasedPermissions?.includes('READ') ? (
          <>
            <PageHeader
              headerText='All Features Setups'
              additionalComponent={
                <AddFeatureAction
                  hasCreatePermission={featureBasedPermissions.includes(
                    'CREATE'
                  )}
                />
              }
            />

            <motion.div
              variants={sectionAnimVariants}
              initial='initial'
              animate='animate'
            >
              <FilterFeaturesDiv />

              {featureList.length ? (
                <div className='grid grid-cols-1 md:grid-cols-3 xl:grid-cols-4 gap-5 px-2'>
                  {featureList.map((feature) => (
                    <SetupCard
                      key={feature.id}
                      title={formatFeatureName(feature.name)}
                      label={formatFeatureName(feature.name)}
                      deleteBtnTitle='Remove Feature'
                      showDeleteModalHandler={
                        featureBasedPermissions.includes('DELETE')
                          ? () => {
                              setShowDeleteModal(true);
                              setTargetedFeature(feature);
                            }
                          : undefined
                      }
                    >
                      <div className='border-t border-dashed border-legal-dark-blue pt-1'>
                        <SetupCardBodyInfo
                          label='Description'
                          info={feature.description}
                        />
                      </div>
                    </SetupCard>
                  ))}
                </div>
              ) : (
                <NoTableDataFound message='No Features Found!!' />
              )}
            </motion.div>
          </>
        ) : (
          <AcademiaLoading />
        )
      ) : isError ? (
        <AcademiaNotFound message='Failed to load features data!!' />
      ) : null}
    </section>
  );
};

export default ShowAllFeatures;
